import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TS_HorizontalWorkspace } from '@nu-art/ts-workspace-frontend/index';
import './Page_ResourceEditor_V2.scss';
import { RoutePermissions } from '@nu-art/permissions-frontend/index';
import { workspaceKey_ResourceEditor } from './workspace-config.js';
import { EditorWrapper_ResourcesV2 } from './presenter/EditorWrapper_ResourcesV2.js';
import { SearchSelector_BaseManagerUI } from '@app/styles/frontend/ui/ui-manager/Selector_Base/SearchSelector_BaseManagerUI';
import { Page_BaseManagerUI_SingleType_Proto, Renderer_SearchResult, SearchItemV3_With_ID } from '@app/styles';
import { ModuleFE_Resource } from '../../_entity.js';
import { QPageMessage } from '../q-components/index.js';
export class Page_ResourceEditor_V2 extends Page_BaseManagerUI_SingleType_Proto {
    // ######################## Static ########################
    static Route = {
        key: 'resource-editor',
        path: 'resource-editor',
        Component: this,
        enabled: RoutePermissions(ModuleFE_Resource.permissions.ui.Release),
        modulesToAwait: [ModuleFE_Resource],
    };
    static searchItemKey_Resource = ModuleFE_Resource.dbDef.dbKey;
    static SearchableItem_Resource = SearchItemV3_With_ID({
        module: ModuleFE_Resource,
        type: Page_ResourceEditor_V2.searchItemKey_Resource,
        route: Page_ResourceEditor_V2.Route,
        entityName: ModuleFE_Resource.dbDef.entityName,
        entityLabel: 'Resource',
        groupId: ['Advisor'],
        mapper: (item) => [item.label],
        tags: [],
        renderer: (item, selected, onClickCallback) => {
            return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: Page_ResourceEditor_V2.searchItemKey_Resource, itemLabel: item.label, entityLabel: 'Resource', hierarchy: 'Resource', selected: selected, onClickCallback: onClickCallback });
        },
        resultRenderer: (item) => {
            const dbItem = ModuleFE_Resource.cache.unique(item);
            if (!dbItem)
                return _jsx(_Fragment, {});
            return _jsx(_Fragment, {});
        }
    });
    static defaultProps = {
        searchItems: [Page_ResourceEditor_V2.SearchableItem_Resource]
    };
    workspace = () => ({
        id: 'resources-editor',
        key: workspaceKey_ResourceEditor,
        renderers: {
            horizontalSpace: TS_HorizontalWorkspace,
        },
        instances: {
            selector: () => {
                return _jsx(SearchSelector_BaseManagerUI, { searchItems: [Page_ResourceEditor_V2.SearchableItem_Resource], onSearchItemSelected: (item) => this.onSearchResultSelected(item.id, item.type), selectedItem: this.state.selectedResult, buttons: [{
                            label: 'Add Resource',
                            action: this.onCreateNewResource.bind(this)
                        }] });
            },
            presenter: () => {
                if (!this.state.selectedItem)
                    return _jsx(QPageMessage, { message: 'Resource Manager' });
                return _jsx(EditorWrapper_ResourcesV2, { editable: this.state.selectedItem });
            },
        }
    });
    onCreateNewResource() {
        this.clearSelectedResult();
        this.setState({ selectedItem: this.getEditableItem() });
    }
    getInitialObject() {
        return {};
    }
}
//# sourceMappingURL=Page_ResourceEditor_V2.js.map